import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-invite-members-modal',
  templateUrl: './invite-members-modal.component.html',
  styleUrls: ['./invite-members-modal.component.scss']
})
export class InviteMembersModalComponent {

  constructor(private dialogRef: MatDialogRef<any>) { }

  close(result?: any) {
    this.dialogRef.close(result);
  }
}
